import { FC } from "react";
import "./style.scss";

export type TrafficLightStatus =
    | "green"
    | "amber"
    | "yellow"
    | "red"
    | "no_data"
    | string;

export const TrafficLight: FC<{
    status?: TrafficLightStatus | null;
    label?: string;
    compact?: boolean;
}> = ({ status = "no_data", label, compact = false }) => {
    const normalized = status === "yellow" ? "amber" : status || "no_data";
    const defaultLabel =
        normalized === "green"
            ? "On track"
            : normalized === "amber"
              ? "Needs attention"
              : normalized === "red"
                ? "Off track"
                : "Not enough data";

    return (
        <span
            className={`ui-traffic-light-wrap ${compact ? "is-compact" : ""}`}
        >
            <span
                className={`ui-traffic-light is-${normalized}`}
                aria-label={label || defaultLabel}
                role="img"
            >
                <i className="is-green" />
                <i className="is-amber" />
                <i className="is-red" />
            </span>
            {label !== undefined && <span>{label || defaultLabel}</span>}
        </span>
    );
};
